module.exports = __webpack_public_path__ + "h5/img/record1.dbae6c3b.png";